module.exports = __webpack_public_path__ + "img/as_con1_img.d0877856.png";